module.exports = __webpack_public_path__ + "static/pintura.77c7aa81.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/inicio-soluciones/pintura.jpg
// module id = 359
// module chunks = 35783957827783